import { ButtonComponent } from '@/components/commons'
import { Text } from '@/components/commons/typography/Text'
import { RecommendationCard } from 'containers/profile-network/components/profiles-cards/RecommendationCard'

import { RecommendationCardLoading } from 'containers/recommendations/recommendation-card/RecommendationCardLoading'
import { useDissmissedRecommendationsStore } from 'containers/recommendations/store/recommendations'
import { ProfileRecommendation } from 'containers/recommendations/types/recommendations'
import { useCallback, useEffect, useMemo, useState } from 'react'

interface RecommendationsGroupProps {
  isLoading: boolean
  title: string
  recommendations: ProfileRecommendation[]
  to?: string
  useRandomRecommendations?: boolean
}

const MAX_RECOMMENDATIONS = 3

export const RecommendationsGroup = ({
  isLoading,
  title,
  recommendations,
  to,
  useRandomRecommendations,
}: RecommendationsGroupProps) => {
  const [removedRecommendations, setRemovedRecommendations] = useState<
    string[]
  >([])
  const [removingRecommendation, setRemovingRecommendation] =
    useState<string>('')
  const [initialRecommendations, setInitialRecommendations] = useState<
    ProfileRecommendation[]
  >([])
  const { dismissedRecommendations } = useDissmissedRecommendationsStore()

  const randomIzeRecommendations = useCallback(() => {
    const randomRecommendations = recommendations.sort(
      () => Math.random() - Math.random()
    )
    setInitialRecommendations(randomRecommendations)
  }, [recommendations])

  useEffect(() => {
    if (initialRecommendations.length === 0) {
      randomIzeRecommendations()
    }
  }, [initialRecommendations.length, randomIzeRecommendations, recommendations])

  const removeRecommendation = (recommendationId: string) => {
    setRemovingRecommendation(recommendationId)
    setTimeout(() => {
      setRemovedRecommendations([...removedRecommendations, recommendationId])
      setRemovingRecommendation('')
    }, 350)
  }

  const filterList = useMemo(() => {
    return initialRecommendations
      .filter(
        (recommendation) =>
          !dismissedRecommendations.includes(recommendation.id)
      )
      .slice(0, MAX_RECOMMENDATIONS)
  }, [initialRecommendations, dismissedRecommendations])

  return (
    <div className="flex full-w flex-column gap-14">
      <Text weightClass="font-bold" sizeClass="text-15">
        {title}
      </Text>
      {isLoading &&
        Array.from(Array(MAX_RECOMMENDATIONS).keys()).map((index) => (
          <RecommendationCardLoading key={index + '_recommendation_loading'} />
        ))}
      {!isLoading &&
        filterList?.map((recommendation) =>
          recommendation.id === removingRecommendation ? null : (
            <RecommendationCard
              key={recommendation?.id + '_' + recommendation?.username}
              profile={recommendation}
              onDismiss={removeRecommendation}
              isInRecommendationsColumn
            />
          )
        )}
      <ButtonComponent
        variation="white-bg"
        size="xSmall"
        to={!useRandomRecommendations ? to : undefined}
        onClick={useRandomRecommendations && randomIzeRecommendations}
        label={!!useRandomRecommendations ? 'View Others' : 'View More'}
      />
    </div>
  )
}
